var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * form のスクロール関連の関数
 */
import { sleep } from '@/helpers/common';
import { CLASS_NAME_HEADER } from '@/utils/constants/element/layout';
import { scrollTo } from '@/utils/libs/react-scroll/animateScroll';
/** エラーテキストに付与する className */
export const FIELD_ERROR_DOM_CLASS_NAME = 'form_field_error_dom';
/** エラーテキストの先祖要素（スクロール対象）に付与する className */
export const FIELD_DOM_CLASS_NAME = 'form_field_dom';
/**
 * 共通のエラー用クラスを持つ要素にスクロールする
 * @param offset
 * @param scrollOptions
 * @param selectorFieldErrorDomClassName
 * @param selectorFieldDomClassName
 */
export const scrollToFieldErrorDom = (offset, scrollOptions, selectorFieldErrorDomClassName, selectorFieldDomClassName) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    yield sleep(0);
    const firstErrorElement = document.querySelector(`.${selectorFieldErrorDomClassName || FIELD_ERROR_DOM_CLASS_NAME}`);
    const firstErrorFieldElement = firstErrorElement === null || firstErrorElement === void 0 ? void 0 : firstErrorElement.closest(`.${selectorFieldDomClassName || FIELD_DOM_CLASS_NAME}`);
    const { top } = (_a = firstErrorFieldElement === null || firstErrorFieldElement === void 0 ? void 0 : firstErrorFieldElement.getBoundingClientRect()) !== null && _a !== void 0 ? _a : {};
    if (typeof top !== 'undefined') {
        const headerDom = document.querySelector(`.${CLASS_NAME_HEADER}`);
        const headerHeight = (headerDom === null || headerDom === void 0 ? void 0 : headerDom.offsetHeight) || 0;
        const padding = 40;
        const toY = top + window.pageYOffset + (offset !== null && offset !== void 0 ? offset : -(headerHeight + padding));
        scrollTo(toY, Object.assign(Object.assign({}, (scrollOptions || {})), { smooth: true }));
    }
});
